import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { Calendar } from "../../../../ui/molecules/calendar"
import { MadfarmInput } from "../../../../ui/molecules/input/newInput"
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import TextArea from "../../../../ui/molecules/textArea"
import { ReportingStatusOption, ReportingTypologyOption } from "../../../../utils"
import { setUpdateReportingCustomerOtherODC, setUpdateReportingDetails, setUpdateReportingEntryProtocolId, setUpdateReportingNote, setUpdateReportingReportingDate, setUpdateReportingReportingState, setUpdateReportingReportingType, setUpdateReportingSender } from "../slice"

export function EditReportingForms() {
    const dispatch = useAppDispatch()
    const reportingState = useAppSelector(state => state.reporting)

    return (
        <div className="flex flex-col gap-6">
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Segnalazioni / Modifica</span>
                </div>
                <div className="p-6 flex flex-col gap-4">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                        <Calendar
                            label="Data"
                            errorLabel={reportingState.reportingErrors.reportingDate ? 'Data mancante' : undefined}
                            selected={reportingState.reportingUpdateRequest.reportingDate}
                            onChange={(date) => dispatch(setUpdateReportingReportingDate(date))}
                        />
                        <MadfarmInput
                            label="Mittente"
                            placeholder="Specifica mittente..."
                            error={reportingState.reportingErrors.sender}
                            supportingText={reportingState.reportingErrors.sender ? 'Mittente mancante' : undefined}
                            value={reportingState.reportingUpdateRequest.sender}
                            onChangeText={(text) => dispatch(setUpdateReportingSender(text))}
                        />
                        <MadfarmInput
                            label="Cliente Altro ODC"
                            placeholder="Specifica cliente..."
                            value={reportingState.reportingUpdateRequest.customerOtherODC}
                            onChangeText={(text) => dispatch(setUpdateReportingCustomerOtherODC(text))}
                        />
                    </div>

                    <div className="border-[0.5px] border-neutral-200" />

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <MadfarmStaticSelect
                            label="Tipologia"
                            error={reportingState.reportingErrors.reportingType}
                            errorLabel='Tipologia mancante'
                            placeholder={'Seleziona tipologia...'}
                            value={reportingState.reportingUpdateRequest.reportingType}
                            options={ReportingTypologyOption}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setUpdateReportingReportingType(newValue))
                            }}
                            noOptionsMessage="Nessuna tipologia disponibile"
                        />
                        <MadfarmStaticSelect
                            label="Stato"
                            error={reportingState.reportingErrors.reportingState}
                            errorLabel='Stato mancante'
                            placeholder={'Seleziona stato...'}
                            value={reportingState.reportingUpdateRequest.reportingState}
                            options={ReportingStatusOption}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setUpdateReportingReportingState(newValue))
                            }}
                            noOptionsMessage="Nessuno stato disponibile"
                        />
                    </div>

                    <div className="border-[0.5px] border-neutral-200" />

                    <ProtocolSearch
                        errorLabel={reportingState.reportingErrors.entryProtocolId ? 'Protocollo mancante' : undefined}
                        type='entry'
                        defaultValue={reportingState.reportingUpdateRequest.entryProtocolId}
                        onSelect={(value) => dispatch(setUpdateReportingEntryProtocolId(value))}
                    />

                    <TextArea
                        label='Dettagli della segnalazione'
                        error={reportingState.reportingErrors.details}
                        supportingText={reportingState.reportingErrors.details ? 'Dettagli mancanti' : undefined}
                        value={reportingState.reportingUpdateRequest.details}
                        placeholder="Specificare i dettagli della segnalazione..."
                        onChangeText={(text) => dispatch(setUpdateReportingDetails(text))}
                    />
                    <TextArea
                        label='Note'
                        value={reportingState.reportingUpdateRequest.note}
                        onChangeText={(text) => dispatch(setUpdateReportingNote(text))}
                    />
                </div>
            </div>
        </div>
    )
}